"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.parts = void 0;
const dom_js_1 = require("./dom.js");
const parts_js_1 = require("./parts.js");
const template_factory_js_1 = require("./template-factory.js");
exports.parts = new WeakMap();
const render = (result, container, options) => {
    let part = exports.parts.get(container);
    if (part === undefined) {
        (0, dom_js_1.removeNodes)(container, container.firstChild);
        exports.parts.set(container, part = new parts_js_1.NodePart(Object.assign({ templateFactory: template_factory_js_1.templateFactory }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};
exports.render = render;
